import { render } from "./HalamanHome.vue?vue&type=template&id=03c12754"
import script from "./HalamanHome.vue?vue&type=script&lang=js"
export * from "./HalamanHome.vue?vue&type=script&lang=js"

import "./HalamanHome.vue?vue&type=style&index=0&id=03c12754&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__